import React, { Component } from 'react';
import { connect } from 'react-redux';
import GenericTable from 'screens/components/advanced/GenericTable';
import { importAccessoryFromCatalog, getAccessoryVendors } from 'actions/EntityActions';
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import LOOKUP from 'constants/lookup';
import { mapAccessoryCatalogList } from 'utils/mappers';
import * as types from 'constants/actionTypes';
import { showError } from 'actions/CommonActions';
import { vendorCatelogCrumb } from 'utils/breadcrumbInfo';

class VendorCatalog extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        this.props.getAccessoryVendors();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.importedProductsTime !== undefined && newProps.importedProductsTime !== null && newProps.importedProductsTime !== this.props.importedProductsTime) {
            let importCount = newProps.importedProducts.split(',').length;
            this.props.showError(`Import success, ${importCount} new products are imported. SKUs are ${newProps.importedProducts}`);
        }

        if (newProps.importedProductsErrorTime !== undefined && newProps.importedProductsErrorTime !== null && newProps.importedProductsErrorTime !== this.props.importedProductsErrorTime) {
            this.props.showError(`${newProps.importedProductsError}`);
        }
    }

    importToTechPOS = (vendor) => {
        this.props.importAccessoryFromCatalog(vendor.id);
    }

    shopOnline = (shopUrl) => {
        window.open(shopUrl, "_blank");
    }

    render() {
        let accessoryVendors = this.props.accessoryVendors;
        return (
            <Grid headerContent={vendorCatelogCrumb}>
                <section className="page-top">
                    <div className="page-title">
                        <h2> {"Accessory Vendor Catalog"}</h2>
                        <h5>Import catalogue directly from the listed vendor below, including details provided by vendor PO ie: SKU, product name, description, images, cost.</h5>
                    </div>
                </section>
                <CardSimple>
                    <GenericTable
                        className="table_center tableHeaderTxt tableVendorBtnColor"
                        tableBodyClassName="patients-table"
                        multiSelectable={false}
                        enableSelectAll={false}
                        selectable={false}
                        stripedRows={true}
                        columns={LOOKUP.vendor.accessoryVendorCatalogTableColumns}
                        rows={mapAccessoryCatalogList(accessoryVendors, this.importToTechPOS, this.shopOnline)}
                    />
                </CardSimple>
            </Grid>);
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        accessoryVendors: state.entity.accessoryVendors || [],
        importedProducts: state.entity.importedProducts,
        importedProductsError: state.entity.importedProductsError,
        importedProductsTime: state.entity.importedProductsTime,
        importedProductsErrorTime: state.entity.importedProductsErrorTime
    };
}

function mapDispatchToProps(dispatch) {
    return {
        importAccessoryFromCatalog: (vendorId) => dispatch(importAccessoryFromCatalog(vendorId)),
        getAccessoryVendors: () => dispatch(getAccessoryVendors()),
        showMessage: (message) => dispatch({ type: types.DIALOG_ALERT_OPEN, message: message }),
        showError: (message) => dispatch(showError(message))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VendorCatalog);